<template>
  <div class="m-news">
    <Head :index="'10'"></Head>

    <!-- 分类导航 -->
    <div class="category-bar">
      <el-select v-model="selectedType" @change="handleCategoryClick" placeholder="选择栏目" class="category-select">
        <el-option
          v-for="cat in categories"
          :key="cat.id"
          :label="cat.name"
          :value="cat.id"
        ></el-option>
      </el-select>
    </div>

    <!-- 栏目描述 -->
    <div class="section-desc">{{ currentCategory.description }}</div>

    <!-- 添加按钮 -->
    <div v-if="showAddButton" class="add-bar">
      <button class="add-btn" @click="handleAdd()">+ 添加新内容</button>
    </div>

    <!-- 新闻列表 -->
    <div class="news-list">
      <div v-for="item in list" :key="item.id" class="news-card">
        <div class="card-header">
          <h3 class="card-title">{{ item.title }}</h3>
          <span :class="item.verify == 1 ? 'badge-pass' : 'badge-pending'">
            {{ item.verify == 1 ? '已审核' : '待审核' }}
          </span>
        </div>
        <div class="card-meta">
          <span v-if="item.createTime" class="card-time">{{ item.createTime }}</span>
        </div>
        <div class="card-actions">
          <button class="action-btn view" @click="handleView(item)">查看</button>
          <button class="action-btn edit" @click="handleEdit(item)">编辑</button>
          <button class="action-btn del" @click="handleDelete(item)">删除</button>
        </div>
      </div>
      <div v-if="list.length === 0 && !loading" class="load-status empty">暂无数据</div>
      <div v-if="hasMore && !loading" class="load-more-bar">
        <button class="load-more-btn" @click="loadMore">加载更多</button>
      </div>
      <div v-if="loading" class="load-status">加载中...</div>
      <div v-if="!hasMore && list.length > 0" class="load-status">没有更多了</div>
    </div>

    <!-- 新增/编辑 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogForm" fullscreen :title="editingId ? '编辑新闻' : '添加新闻'">
      <div style="padding:0 10px">
        <el-form ref="newsForm" label-width="70px" :model="newsForm">
          <el-form-item label="标题" prop="title">
            <el-input type="text" placeholder="请输入标题" autocomplete="off" v-model="newsForm.title"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <vue-ueditor-wrap
              v-model="newsForm.content"
              editor-id="m-editor6"
              :config="editorConfig"
              :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            />
          </el-form-item>
          <el-form-item label="审核">
            <el-radio-group v-model="newsForm.verify">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <el-button type="primary" @click="submitForm()" :loading="submitting">{{ editingId ? '保存' : '确定' }}</el-button>
        <el-button @click="dialogForm = false">取消</el-button>
      </template>
    </el-dialog>

    <!-- 查看详情 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogDetail" fullscreen title="新闻详情">
      <div v-if="detailData" class="detail-wrap">
        <h2 class="detail-title">{{ detailData.title }}</h2>
        <div class="detail-meta">
          <span v-if="detailData.createTime">时间：{{ detailData.createTime }}</span>
          <span v-if="detailData.verify != null">
            状态：{{ detailData.verify == 1 ? '已审核' : '待审核' }}
          </span>
        </div>
        <div class="detail-content" v-html="detailData.content"></div>
      </div>
      <template #footer>
        <el-button @click="dialogDetail = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Head from "@/components/header.vue";
import api from "@/request/api";
import VueUeditorWrap from "vue-ueditor-wrap";
import base from "@/request/base";
export default {
  data() {
    return {
      editorConfig: {
        serverUrl: base.baseURL + 'news/upload',
        UEDITOR_HOME_URL: '/static/UEditor/',
        UEDITOR_CORS_URL: '/static/UEditor/',
        initialFrameHeight: 200,
        toolbars: [[
          'bold', 'italic', 'underline', 'strikethrough',
          'fontsize',
          'justifyleft', 'justifycenter', 'justifyright',
          'insertorderedlist', 'insertunorderedlist',
          'link', 'unlink',
          'simpleupload', 'insertvideo',
          'removeformat',
          'undo', 'redo',
          'source'
        ]]
      },
      newsForm: { title: "", content: "", verify: 0 },
      editingId: null,
      submitting: false,
      categories: [
        { id: 1, name: '家族新闻和公告', description: '发布关于家族的重大新闻、重要公告和通知。' },
        { id: 2, name: '家族成就和荣誉', description: '展示家族成员在个人事业、学术研究、社会贡献等方面的成就和获得的荣誉。' },
        { id: 3, name: '家族各分支情况', description: '介绍各分支迁徙时间、始迁(祖)人、成员数量、文化结构、分布地区、主要人物、经济状况等。' },
        { id: 4, name: '家族活动和聚会', description: '记录家族组织的各种活动，如祭祀活动、团聚、庆祝活动、公益活动等，以及这些活动的文字、照片、视频。' },
        { id: 5, name: '家族成员的动态', description: '分享家族成员的生活点滴、旅行见闻、学习心得等，增进家族成员之间的了解和亲近感。' },
        { id: 6, name: '家族文化的传承', description: '介绍家族历史、祖先事迹、家族故事、家族传统和价值观，家规、家训教育等。' },
        { id: 7, name: '家族教育和发展', description: '探讨家族对下一代教育的重视，包括家庭教育理念、教育资源的利用以及家族成员的职业发展支持。' },
        { id: 8, name: '家族之社会责任', description: '展示家族及其成员在社会责任方面的努力和贡献，如扶贫救困、慈善捐赠、风义勇为等。' },
        { id: 9, name: '家族的财产管理', description: '涉及家族财富的管理和传承，包括家族捐助、集资款(物)的使用、管理情况公示，以及家族有形与无形资产的传承与保护。' },
      ],
      permission: -1,
      selectedType: 1,
      currentCategory: {},
      list: [],
      page: 1,
      limit: 10,
      total: 0,
      loading: false,
      dialogForm: false,
      dialogDetail: false,
      detailData: null,
    };
  },
  components: { Head, VueUeditorWrap },
  computed: {
    totalPage() {
      return Math.ceil(this.total / this.limit) || 1;
    },
    hasMore() {
      return this.page < this.totalPage;
    },
    showAddButton() {
      if (this.permission === 0) return true;
      if (this.permission > 0) return [3, 4, 8].includes(this.selectedType);
      return this.selectedType === 5;
    }
  },
  mounted() {
    this.currentCategory = this.categories.find(c => c.id === this.selectedType);
    this.loadData();
    api.getpermission(localStorage.getItem('fid'))
      .then(res => { this.permission = res.data; })
      .catch(() => { this.permission = -1; });
  },
  methods: {
    handleCategoryClick(type) {
      if (this.selectedType === type) return;
      this.selectedType = type;
      this.currentCategory = this.categories.find(c => c.id === type);
      this.page = 1;
      this.list = [];
      this.loadData(true);
    },
    loadData(replace = false) {
      this.loading = true;
      api.getnews({ type: this.selectedType, page: this.page, limit: this.limit, fid: localStorage.getItem('fid') })
        .then(res => {
          if (res.code === 0) {
            const data = res.data || [];
            this.list = replace ? data : this.list.concat(data);
            this.total = res.count || 0;
          }
        })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    },
    loadMore() {
      if (this.loading || !this.hasMore) return;
      this.page++;
      this.loadData();
    },
    handleAdd() {
      this.editingId = null;
      this.newsForm = { title: "", content: "", verify: 0 };
      this.dialogForm = true;
    },
    handleView(item) {
      this.detailData = null;
      api.newsDetail({id: item.id, fid: localStorage.getItem('fid')}).then(res => {
        if (res.code === 0) {
          this.detailData = res.data;
          this.dialogDetail = true;
        } else {
          this.$message({ message: res.msg || '获取详情失败', type: 'warning' });
        }
      }).catch(() => { this.$message({ message: '获取详情失败', type: 'error' }); });
    },
    handleEdit(item) {
      this.editingId = item.id;
      this.newsForm = { title: "", content: "", verify: 0 };
      api.newsDetail({id: item.id, fid: localStorage.getItem('fid')}).then(res => {
        if (res.code === 0) {
          this.newsForm = {
            title: res.data.title || "",
            content: res.data.content || "",
            verify: res.data.verify != null ? res.data.verify : 0
          };
          this.dialogForm = true;
        } else {
          this.$message({ message: res.msg || '获取详情失败', type: 'warning' });
        }
      }).catch(() => { this.$message({ message: '获取详情失败', type: 'error' }); });
    },
    handleDelete(item) {
      this.$confirm('确定删除"' + item.title + '"?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        api.newsDelete({id: item.id, fid: localStorage.getItem('fid')}).then(res => {
          if (res.code === 0) {
            this.$message({ message: '删除成功', type: 'success' });
            this.page = 1;
            this.list = [];
            this.loadData(true);
          } else {
            this.$message({ message: res.msg || '删除失败', type: 'warning' });
          }
        }).catch(() => { this.$message({ message: '删除失败', type: 'error' }); });
      }).catch(() => {});
    },
    submitForm() {
      if (!this.newsForm.title.trim()) {
        this.$message({ message: '请输入标题', type: 'warning' });
        return;
      }
      this.submitting = true;
      const data = {
        title: this.newsForm.title,
        content: this.newsForm.content,
        classid: this.selectedType,
        verify: this.newsForm.verify,
        fid: localStorage.getItem('fid')
      };
      const request = this.editingId
        ? api.newsUpdate({ id: this.editingId, title: data.title, content: data.content, classid: data.classid, verify: data.verify, fid: data.fid })
        : api.newsAdd(data);

      request.then(res => {
        this.submitting = false;
        if (res.code === 0) {
          this.$message({ message: this.editingId ? '修改成功' : '添加成功', type: 'success' });
          this.dialogForm = false;
          this.page = 1;
          this.list = [];
          this.loadData(true);
        } else {
          this.$message({ message: res.msg || '操作失败', type: 'warning' });
        }
      }).catch(() => {
        this.submitting = false;
        this.$message({ message: '操作失败', type: 'error' });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.m-news {
  height: 100%;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.category-bar {
  background: #fff;
  padding: 10px 15px;
  border-bottom: 1px solid #eee;

  .category-select {
    width: 100%;
  }
}

.section-desc {
  font-size: 12px;
  color: #999;
  padding: 10px 15px;
  background: #fff;
  border-bottom: 1px solid #eee;
  line-height: 1.5;
}

.add-bar {
  padding: 10px 15px;
  text-align: right;

  .add-btn {
    display: inline-block;
    padding: 8px 20px;
    border: none;
    border-radius: 6px;
    background: #e04428;
    color: #fff;
    font-size: 14px;
    cursor: pointer;

    &:active { opacity: 0.8; }
  }
}

.news-list {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 15px 20px;
}

.news-card {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
  }

  .card-title {
    font-size: 15px;
    color: #333;
    font-weight: 500;
    line-height: 1.4;
    flex: 1;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .badge-pass {
    font-size: 11px;
    color: #67c23a;
    background: #f0f9eb;
    padding: 2px 8px;
    border-radius: 10px;
    flex-shrink: 0;
  }

  .badge-pending {
    font-size: 11px;
    color: #e6a23c;
    background: #fdf6ec;
    padding: 2px 8px;
    border-radius: 10px;
    flex-shrink: 0;
  }

  .card-meta {
    margin-top: 8px;
    font-size: 12px;
    color: #999;
  }

  .card-actions {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    gap: 10px;
  }

  .action-btn {
    flex: 1;
    padding: 8px 0;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fff;
    font-size: 13px;
    text-align: center;
    cursor: pointer;

    &:active { opacity: 0.7; }

    &.view { color: #409eff; border-color: #409eff; }
    &.edit { color: #67c23a; border-color: #67c23a; }
    &.del { color: #f56c6c; border-color: #f56c6c; }
  }
}

.load-status {
  text-align: center;
  padding: 20px 0;
  font-size: 13px;
  color: #999;

  &.empty { padding: 60px 0; font-size: 14px; }
}

.load-more-bar {
  text-align: center;
  padding: 10px 0 20px;

  .load-more-btn {
    padding: 8px 30px;
    border: 1px solid #ddd;
    border-radius: 20px;
    background: #fff;
    color: #666;
    font-size: 13px;
    cursor: pointer;

    &:active { background: #f5f5f5; }
  }
}

.detail-wrap {
  padding: 10px 0;

  .detail-title {
    text-align: center;
    font-size: 20px;
    color: #333;
    margin-bottom: 12px;
    line-height: 1.4;
  }

  .detail-meta {
    text-align: center;
    color: #999;
    font-size: 12px;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebedf0;

    span + span { margin-left: 15px; }
  }

  .detail-content {
    font-size: 14px;
    line-height: 1.8;
    color: #333;
    word-wrap: break-word;
    overflow: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/news.vue